import SectionPage from "@/components/common/section-page";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import BeachDestinationCard from "@/components/site-officiel/ivoirexperience/beach-destination-card";
import { beachDestinations } from "@/lib/data/beach-destinations";
import { THE_PLACE_TO_BE_HERO_IMAGE, THE_PLACE_TO_BE_TITLE } from "@/lib/data/the-place-to-be";

export default function ThePlaceToBePage() {
    return (
        <div className="flex flex-col gap-6 pb-6 bg-slate-100">
            <CardTitle
                title={THE_PLACE_TO_BE_TITLE}
                backgroundImgSrc={THE_PLACE_TO_BE_HERO_IMAGE}
            />

            <SectionPage sectionType="2xl">
                <div className="flex justify-between items-center">
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href="/">Accueil</BreadcrumbLink>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator />
                            <BreadcrumbItem>
                                <BreadcrumbPage>Ivoire Experience</BreadcrumbPage>
                            </BreadcrumbItem>
                            <BreadcrumbSeparator />
                            <BreadcrumbItem>
                                <BreadcrumbPage>{THE_PLACE_TO_BE_TITLE}</BreadcrumbPage>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>
                </div>
            </SectionPage>

            <SectionPage sectionType="2xl">
                <AwesomeCard
                    className="bg-[#eef5f9] text-muted-foreground border border-sky-100"
                    titleClassName="text-bleu-marine"
                >
                    <div className="prose max-w-none">
                        <h2 className="text-2xl font-exo-bold text-bleu-marine mb-4">
                            Le Littoral ivoirien : là où la nature rencontre l&apos;évasion
                        </h2>
                        <p>
                            Laissez-vous séduire par l&apos;appel de l&apos;océan. Découvrez nos plages
                            paradisiaques, d&apos;Assinie à Tabou, et vivez un été inoubliable sur le
                            littoral ivoirien.
                        </p>
                    </div>
                </AwesomeCard>
            </SectionPage>

            <SectionPage sectionType="2xl">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-exo-bold text-bleu-marine mb-2">
                        Nos destinations plages
                    </h2>
                    <p className="text-lg text-bleu-ciel">
                        Découvrez notre sélection des plages du littoral ivoirien
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                    {beachDestinations.map((destination) => (
                        <BeachDestinationCard key={destination.name} destination={destination} />
                    ))}
                </div>
            </SectionPage>
        </div>
    );
}
